function formatIsoDateForLabel(isoDate) {
    if (!isoDate) return "";

    try {
        const parsed = new Date(`${isoDate}T12:00:00`);
        if (Number.isNaN(parsed.getTime())) return isoDate;

        return new Intl.DateTimeFormat("en-US", {
            month: "short",
            day: "numeric",
            year: "numeric",
        }).format(parsed);
    } catch {
        return isoDate;
    }
}

export function buildChartDateContextLabel({ selectedDate = null, startDate = null, endDate = null } = {}) {
    if (startDate && endDate) {
        if (startDate === endDate) {
            return `As of ${formatIsoDateForLabel(startDate)}`;
        }

        return `${formatIsoDateForLabel(startDate)} - ${formatIsoDateForLabel(endDate)}`;
    }

    if (selectedDate) {
        return `As of ${formatIsoDateForLabel(selectedDate)}`;
    }

    return "As of Today";
}
